import jwtInterceptor from '/src/shared/jwtInterceptor'

const apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

const actions = {
  async getReportItems()
  {
    let url = apiUrl + 'getReportItems';
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  }

};

export default {
  namespaced: true,
  actions
}